export default function groupMemberReducer(groupMember, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "ringSeconds":
      return { ...groupMember, [action.type]: Number(action.value) };

    default:
      return { ...groupMember, [action.type]: action.value };
  }
}
